import { authApi } from "./";

export const initialize = async () => {
  const response = await authApi.post("cart/initialize", undefined, {});
  return response ?? {};
};
export const getCart = async () => {
  const response = await authApi.post("cart/get", undefined, {});
  return response ?? [];
};
/**
 * Update cart item
 * @param c
 * @returns
 */
export const updateCart = async (
  cartId: string,
  productId: string,
  quantity: number
) => {
  const response = await authApi.post("cart/update", {
    cartId,
    productId,
    quantity,
  });

  return response;
};
export const removeCartItem = async (
  cartId: string | number,
  productId: string
) => {
  const response = await authApi.post("cart/remove", {
    cartId,
    productId,
  });

  return response;
};

export const completeOrder = async (
  cartId: string | number,
  customerOrder: string
) => {
  const response = await authApi.post("cart/complete", {
    cartId,
    customerOrder,
  });
  return response;
};

// Clear the cart
export const clearCart = async (cartId: string | number) => {
  await authApi.post("cart/reset", { cartId }, {});
};
